module.exports = {"common":{"select_lang":"Ngôn ngữ"}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en.json
// module id = 622
// module chunks = 0